// eslint-disable-next-line no-magic-numbers
const getTimeout = (): number => 300;

export { getTimeout };
